import { useState,useEffect } from "react";
import {getOsobeDomace} from "../../util/apiOsoba";
import {getKnjigeShort} from "../../util/apiKnjiga";
import { getDrzaveById } from "../../util/apiDrzava";
import {Box, Badge, Divider, useToast, Text} from "@chakra-ui/react"
export default function DolazakFilterInfo({size='xs',leftsidewidth='25%',rightsidewidth='75%', _knjige=[],_tipovidolazaka=[],_posjednici=[],
_drzave=[],_period={datod:'1900-01-01',datdo:'1900-01-01'}}) {

const [posjednici,setPosjednici]=useState([]);
const [drzave,setDrzave]=useState([]);
const [knjige,setKnjige]=useState([]);
const [err,setErr]=useState("");
const toast=useToast();

useEffect(() => {
    
    
    const fetchDrzave=async()=>{
        try {
            const _res=await getDrzaveById({drzave:_drzave});
            if (_res.status===200) {
              setDrzave(_res.res);
            } else {
              throw new Error(_res.message);
            }
          } catch (error) {
            setErr(error.message);
          }
    }
    const fetchPosjednici=async()=>{
        try {
            const _res=await getOsobeDomace({osobe:_posjednici});
            if (_res.status===200) {
              setPosjednici(_res.res);
            } else {
              throw new Error(_res.message);
            }
          } catch (error) {
            setErr(error.message);
          }
      }
      const fetchKnjige=async()=>{
        try {
            const _res=await getKnjigeShort();
            if (_res.status===200) {
              setKnjige(_res.res);
            } else {
              throw new Error(_res.message);
            }
          } catch (error) {
            setErr(error.message);
          }
      }

  if (_posjednici.length!==0) {
    fetchPosjednici();
  }
  if (_knjige.length>0) {
    fetchKnjige();
  }
 
  if (_drzave.length>0) {
    fetchDrzave();
  }
  
}, [_knjige.length,_posjednici.length,_drzave.length,_drzave,_posjednici])

const showErr=()=>{
    if (err!=="") {
      setErr("");
      return(
      toast({
        title:"Greška kod dohvata podataka.",
        status:"error",
        description:err,
        isClosable:true,
        duration:2000,
        position:"top-right",
    }));
    
    }
  }

const getKnjige=()=>{
    return (
        <>
        {knjige.map((item,index)=>{
            if (_knjige.includes(String(item.id))) {
                return (<Box key={index} mr={'8px'} mb={'2px'}><Badge>{item.naziv}</Badge></Box>)    
            } else {
                return null;
            }
            
        })}
        </>
    )
}
const Knjige=()=>{
    if (_knjige.length>0 && err==="" && knjige.length>0) {
        return (
            <>
        <Box display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                
                <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'semibold'}>
                    Knjige
                </Box>
                
                <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                    {getKnjige()}
                </Box>
            </Box>
            <Divider/>
            </>
        )    
    }
    
}
const getPosjednici=()=>{
    return (
        <>
        {posjednici.map((item,index)=>{
            if (_posjednici.includes(item.id)) {
                return (<Box key={index} mr={'8px'} mb={'2px'}><Badge>{item.naziv}</Badge></Box>)    
            } else {
                return null;
            }
            
        })}
        </>
    )
}
const Posjednici=()=>{
    if (_posjednici.length>0 && err==="" && posjednici.length>0) {
        return (
            <>
            <Box display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'semibold'}>
                        Posjednici
                    </Box>
                    
                    <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                        {getPosjednici()}
                    </Box>
                </Box>
                <Divider/>
            </>
        )
    }
    
}
const getUvoz=()=>{
    return (
        <>
        {drzave.map((item,index)=>{
            
                return (<Box key={index} mr={'8px'} mb={'2px'}><Badge>{item.naziv}</Badge></Box>)    
            
            
        })}
        </>
    )
}
const Uvoz=()=>{
    if (_drzave.length>0 && err==="" && drzave.length>0) {
        return (
            <>
            <Box display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'semibold'}>
                        Uvoz
                    </Box>
                    
                    <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                        {getUvoz()}
                    </Box>
                </Box>
                <Divider/>
            </>
        )
    }
    
}


const DolasciTipovi=()=>{
  if (_tipovidolazaka.length!==0) {
      return (
          <>
          <Box display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
              
              <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'bold'}>
                  Odlasci
              </Box>
              <Box w={rightsidewidth} fontSize={size} fm={'2px'} p={'2px'} >
                  <Box display={'flex'} flexDir={'row'}>
                      <Box w={'33%'} fontSize={size}>
                          Kupnja
                      </Box>
                      <Box w={'33%'} fontSize={size}>
                          Uvoz
                      </Box>
                      <Box w={'34%'} fontSize={size}>
                          Teljenje
                      </Box>
                  </Box>
                  <Box display={'flex'} flexDir={'row'}>
                      <Box w={'33%'}>
                          <Badge>{_tipovidolazaka.includes('DKUP')?"DA":"NE"}</Badge>
                      </Box>
                      <Box w={'33%'}>
                      <Badge>{_tipovidolazaka.includes('DUVOZ')?"DA":"NE"}</Badge>
                      </Box>
                      <Box w={'34%'}>
                      <Badge>{_tipovidolazaka.includes('DTELJ')?"DA":"NE"}</Badge>
                      </Box>
                  </Box>
              </Box>
          </Box>
          <Divider/>
          </>
      )
  }
  
}

const Period=()=>{
    if (_period.datdo!=='1900-01-01' && _period.datod!=='1900-01-01') {
        return (
            <>
            <Box display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'semibold'}>
                        Period
                    </Box>
                    
                    <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                        <Badge>
                            {new Date(_period.datod).toLocaleDateString('hr-HR')} - {new Date(_period.datdo).toLocaleDateString('hr-HR')}
                        </Badge>
                    </Box>
                </Box>
                <Divider/>
            </>
        )
    }
}

const retDisplay=()=>{
    if (_knjige.length===0 && _tipovidolazaka.length===0 &&  _posjednici.length===0 && 
        _drzave.length===0 &&  (_period.datod==='1900-01-01' && _period.datdo==='1900-01-01')) {
       return ( <>
            <Text fontSize={'lg'} fontWeight={'normal'}>Nema aktivnih filtera</Text>
        </>)
    } else {
        return (
            <>
                 {Knjige()}
                 {DolasciTipovi()}
                 {Posjednici()}
                 {Uvoz()}
                 {Period()}
                {showErr()}
            </>
        )
    }
}
  return (
    <Box>
        {retDisplay()}
    </Box>
  )
}
